/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import Button from "../Button";
import { isEmpty, each, forEach, get, isArray } from "lodash";
import { viewLoading } from "../../utils/loading";
import { fileUpload, formatBytes } from "../../utils/file";
import systemAlert from "../../utils/systemAlert";
import { ocrReceipt } from "../../apis/ocr";
import { classnames } from "../../utils/text";
import { v4 as uuidv4 } from "uuid";
import FileInfo from "../File/FileInfo";
import DownloadIcon from "../../assets/images/icon/download-icon.svg";
import Icon from "../Icon";
import { download } from "../../utils/download";
import { CheckBox } from "../CheckBox/idnex";
import ToolTip from "../ToolTip/ToolTip";
const DropzoneComponent = (props) => {
  const {
    // selectedFiles,
    // setselectedFiles,
    field,
    onChange,
    buttonLabel = "파일추가",
    // accept = "image/*",
    accept = "",
    isSingle = false,
    isNoClick = false,
    isMemo = false,
    addTextAction,
    textAreaDisabled = false,
    //maxLength = 100,
    receiptOcrCallback,
    // isPreview = false,
    form,
    mode = "create",
    disabled,
    isAdmin = false,
  } = props;

  const [selectedFileSize, setSelectedFileSize] = useState("");
  const [selectedFiles, setselectedFiles] = useState([]);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [isNotCompress, setIsNotCompress] = useState(isAdmin);

  useEffect(() => {
    if (form && field && field.key) {
      const defaultFileList = (field?.filesKey && form[field.filesKey]) ? form[field.filesKey] : form[field.key] ? form[field.key] : [];
      setselectedFiles(isArray(defaultFileList) ? defaultFileList : []);
    }
  }, []);

  useEffect(() => {
    if (
      form &&
      field &&
      field.key &&
      field.changeDefaultFile
    ) {

      if (!isEmpty(get(form, `[${field.key}]`))
        && !isEmpty(get(form, `[${field.key}][0]`))) {
        setselectedFiles(form[field.key]);
      } else if (!isEmpty(get(form, `[${field.filesKey}]`))
        && !isEmpty(get(form, `[${field.filesKey}][0]`))) {
        setselectedFiles(form[field.filesKey]);
      }
    }
  }, [form]);

  const [uuid] = useState(uuidv4());
  const receipt = (file) => {
    viewLoading("OCR 인식중입니다.");
    ocrReceipt(file.fileUrl)
      .then((res) => {
        receiptOcrCallback({ data: res, onChange });
      })
      .finally(() => {
        viewLoading(false);
      });
  };

  const handleAcceptedFiles = async (files) => {
    if (isEmpty(files)) {
      systemAlert("유효하지 않는 파일입니다.");
      return;
    }

    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );

    viewLoading(true);
    const _files = [];
    for (let file of files) {
      try {
        const _file = await fileUpload(file, true, isNotCompress);
        _files.push(_file);
      } catch (error) { }
    }
    viewLoading(false);
    if (isSingle) {
      setselectedFiles([..._files]);
    } else {
      setselectedFiles([...selectedFiles, ..._files]);
    }
  };

  useEffect(() => {
    let size = 0;
    forEach(selectedFiles, (file) => {
      size += file.size;
    });
    setSelectedFileSize(formatBytes(size));
    onChange({
      [get(field, "key") || "files"]: selectedFiles?.filter(f => !!f)?.map((d) => d.fileIdx) || [],
      ...(field?.filesKey ? { [field?.filesKey]: selectedFiles } : {})
    });
  }, [selectedFiles]);

  const handleOnRemove = (file) => {
    setselectedFiles(() => [...selectedFiles.filter((f) => f !== file)]);
  };

  const handleOnTextAreaChange = (e) => {
    setTextAreaValue(e.target.value);
  };

  const downloadAll = () => {
    each(selectedFiles, (file) => {
      const fileName = file.originalName || file.name;
      const fileUrl = file.fileUrl;
      download(fileUrl, fileName);
    });
  };

  return mode === "create" || mode === "modify" ? (
    <>
      <Dropzone
        onDrop={(acceptedFiles) => {
          handleAcceptedFiles(acceptedFiles);
        }}
        multiple={!isSingle}
        noClick={isNoClick}
        accept={accept}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="component-drop-zone">
            <div
              className={classnames("dz-message needsclick", { memo: isMemo })}
              {...getRootProps()}
            >
              <input id={`dropzone-file-${uuid}`} {...getInputProps()} />
              {isMemo ? (
                <textarea
                  name="dropzone-text"
                  //maxLength={maxLength}
                  className="drop-zone-textarea"
                  placeholder="메세지 입력 가능, 파일 드래그 가능"
                  value={textAreaValue}
                  onChange={handleOnTextAreaChange}
                  disabled={textAreaDisabled}
                />
              ) : (
                <span className="drop-zone-discription">
                  드래그해서 파일을 추가할 수 있어요
                </span>
              )}
              <Button
                className="drop-zone-btn"
                action={() => {
                  if (isNoClick) {
                    document.getElementById(`dropzone-file-${uuid}`).click();
                  }
                }}
                color="gray-line"
                disabled={disabled}
                label={
                  <>
                    {buttonLabel}
                    <i className="mdi mdi-arrow-expand-up" />
                  </>
                }
              />
              {isMemo && (
                <Button
                  className="drop-zone-add-text-btn"
                  size="sm"
                  color="line"
                  label="작성"
                  onClick={() => addTextAction(textAreaValue)}
                  disabled={textAreaDisabled}
                />
              )}
            </div>
            {!isEmpty(selectedFiles) && (
              <div className="selected-list-wrap">
                {selectedFiles.map((file, idx) => (
                  <FileInfo
                    files={selectedFiles}
                    selected={idx}
                    file={file}
                    key={idx}
                    remove={handleOnRemove}
                  >
                    {receiptOcrCallback && (
                      <span
                        className="ml-10 color-main-100 cursor-pointer font-size-12"
                        onClick={() => receipt(file)}
                      >
                        내용 자동입력
                      </span>
                    )}
                  </FileInfo>
                ))}
              </div>
            )}
            <div className="selected-list-size-wrap">
              {isMemo && (
                <span className="memo-description">
                  * 입력후 수정불가합니다
                </span>
              )}
              <div className="dropzone-result-info-wrap">
                {/*isMemo && (
                    <span className="max-length-check">
                      <span className="chage-length">{textAreaValue.length}</span>
                      / {maxLength}자
                    </span>
                  )*/}
                <span className="selected-size">
                  총 {`${selectedFileSize}`}
                </span>
              </div>
            </div>
          </div>
        )}
      </Dropzone>
      {/* {isPreview &&
        !isEmpty(selectedFiles)(
          <div className="component-dropzone-preview">
            {selectedFiles.map((file, index) => (
              <div className="img-wrap" key={index}>
                <img alt={file.name} src={file.preview} />
                <IconButton
                  icon={DeleteIcon}
                  className="delete-btn"
                  onClick={() => handleOnRemove(file)}
                />
              </div>
            ))}
          </div>
        )} */}
      {!isAdmin && (
        <div className="component-checkbox-wrap" >
          <CheckBox
            value={isAdmin}
            onChange={setIsNotCompress}
            checked={isNotCompress}
            label={"이미지파일 압축 안함"}
          />
          <ToolTip tooltiptext={"※이미지의 높이 및 넓이가 길거나, 파일용량이 클 경우 압축하여 업로드시 파일이 깨질수가 있습니다."} />
        </div>
      )}

    </>
  ) : isEmpty(selectedFiles) ? (
    <span className="empty-files">첨부파일이 없습니다.</span>
  ) : (
    <div
      className={classnames("file-items-wrap", {
        single: isSingle,
      })}
    >
      {selectedFiles.map((file, idx) => (
        <FileInfo
          files={selectedFiles}
          selected={idx}
          file={file}
          key={idx}
          isDownload
        ></FileInfo>
      ))}
      {!isSingle && (
        <Button
          onClick={downloadAll}
          size="sm"
          color="gray-line"
          className="download-all-button print-out"
        >
          전체 다운로드 <Icon src={DownloadIcon} />
        </Button>
      )}
    </div>
  );
};

export default DropzoneComponent;
